import Markdoc from "@markdoc/markdoc";

export const limitationsHeading = {
  selfClosing: true,
  transform() {
    return new Markdoc.Tag("h3", {}, ["Known limitations"]);
  },
};
